import React from "react";
import { TargetStatus } from "./types";
import { STATUS_CONFIG } from "./constants";
import { tokens } from "../../theme/tokens";

interface Props {
  status: TargetStatus;
  size?: "sm" | "md";
}

const StatusBadge: React.FC<Props> = ({ status, size = "sm" }) => {
  const cfg = STATUS_CONFIG[status];
  if (!cfg) return <span style={{ fontSize: "11px", color: tokens.color.text.secondary }}>{status}</span>;
  return (
    <span
      style={{
        fontSize: size === "md" ? "11px" : "10px",
        fontWeight: 600,
        padding: size === "md" ? "2px 7px" : "1px 5px",
        borderRadius: "4px",
        backgroundColor: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.border}`,
        whiteSpace: "nowrap",
      }}
    >
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
